/// <reference path="DOMAttached.js" />

class PopupEmailPreview extends DOMAttached {
	constructor(el, options) {
		super(el, options);
		this.previewUrl = options.previewUrl;
		this.previewButton = document.getElementById(options.previewButton);
		this.safeObserve(this.previewButton, 'click', this.loadPreview.bind(this));
	}

	loadPreview(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		this.previewWindow = window.open("", "Preview", "height=800,width=800,resizable=1");

		var url = this.previewUrl;
		var params = this.getParameters();

		for (var key in params) {
			url = url.replace(key, encodeURIComponent(JSON.stringify(params[key])));
		}

		this.previewWindow.location.href = url;
		this.previewWindow.focus();
	}
}
